import React, { PureComponent } from 'react'
import { OverlayTrigger, Button } from 'react-bootstrap'
import { GoBackTooltip } from '../../../../components/commons/Tooltips'
import { permissions } from '../../../../constants/backendIds'
import { replaceableFields } from '../../../../constants/dossier/common/replaceableFields'

class FleetsHeader extends PureComponent {
  constructor () {
    super()
    this.state = {
    }
  }

  deleteFleet () {
    this.props.actions.openModal('setDeleteFleetProcess', (deleteDossiers) => { this.props.actions.setDeleteFleetProcess(this.props.fleetId, deleteDossiers) }, null, null, null, [{ id: replaceableFields.fleetCode, value: this.props.fleetData?.fleet?.fleetCode }])
  }

  render () {
    const {
      t, tKey, dirty,
      actions: { goBack, handleSubmitForm }
    } = this.props

    return (
      <div id="fleetsHeader" className='dossierHeader'>
        <div className='dossierHeader-info'>
          <div className='goBack'>
            <OverlayTrigger container={document.getElementById('symb')} placement="bottom" overlay={GoBackTooltip({ t: t })}>
              <a className="_Btn accept stk o-icn" onClick={() => goBack()}><i className="iDocIcon-arrow-left-back"></i></a>
            </OverlayTrigger>
          </div>
          <div className='dossierMainInfo'>
            <i className={'dossierMainInfoIcon ' + 'iDocIcon-file-folder'} />
            <span>{!this.props.fleetData?.fleet?.fleetNumber ? '' : this.props.fleetData.fleet.fleetNumber}</span>
          </div>

        </div>
        <div className='dossierHeader-actions'>
          { this.props.fleetId && this.props.fieldsConfiguration.createFleet && this.props.fieldsConfiguration.createFleet.permission === permissions.editable && (
            <Button id="fleets_btn_save" className="_Btn new" onClick={() => handleSubmitForm()} data-main-submit disabled={!dirty}>
              <i className="iDocIcon-save"></i>
              {t(`${tKey}SAVE`)}
            </Button>
          )}
          { this.props.fleetId && this.props.fleetId !== '-1' && this.props.fieldsConfiguration.deleteFleet && this.props.fieldsConfiguration.deleteFleet.permission === permissions.editable && (
            <Button id="fleets_btn_delete" className="_Btn cancel" onClick={() => this.deleteFleet()}>
              <i className="iDocIcon-delete-forever"></i>
              {t(`${tKey}DELETE`)}
            </Button>
          )}
        </div>
      </div>
    )
  }
}

export default FleetsHeader
